// extracted by mini-css-extract-plugin
export default {"container":"Skeleton_container__hf-0T","animation":"Skeleton_animation__aNRYg"};